
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TheHeader',
  setup() {
    const { header, subHeader ,subSubHeader } = window.__PRE_CONFIG__;
    return {
      header, subHeader, subSubHeader
    };
  }
});
